import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SUBCOMMITTEE_APPLICATION, SUBCOMMITTEE_PERIOD_CHECK } from 'manager/http-constants';
import { Table } from 'primeng/table';
import { CONSTANT } from 'src/app/shared/constant/constant';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { PlatformComponent } from '../platform.component';

@Component({
  selector: 'app-e203',
  templateUrl: './e203.component.html',
  styleUrls: ['./e203.component.scss', '../platform.component.scss'],
})

/**
 * 分科会申請一覧
 */
export class E203Component extends PlatformComponent {
  // 画面.検索フォーム
  e203SearchForm: FormGroup = this.formBuilder.group({
    //ステータス
    status: CONSTANT.EMPTY_STRING,
    // 期間日from
    date1: CONSTANT.EMPTY_STRING,
    // 期間日to
    date2: CONSTANT.EMPTY_STRING,
  });

  /** テーブル状態 */
  @ViewChild('table') table: Table;

  // 分科会一覧リスト結果格納先
  resultDataList: object[] = new Array();

  // 分科会申請ボタン表示状態(true:表示 / false:非表示)
  isDisplay: boolean = false;
  dispCheck: string = 'False';

  // セッション保存名
  sessionTagName: string = 'e203SearchConditions';

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  ngOnInit(): void {
    // 辞書値リストを取得
    this.getSpecCodeList(1102);

    // 分科会申請ボタン表示チェック
    this.checkAppliDate();

    // 分科会一覧リスト結果を取得
    this.getResultDataList();
  }

  /**
   * 分科会一覧リスト結果を取得
   */
  public getResultDataList(screenSearchFlg?: boolean): void {
    // 画面ロードフラグをON(ロード中状態)
    let e203SearchForm: any = JSON.parse(
      JSON.stringify(this.e203SearchForm.value)
    );
    // 検索フォームが空の場合、セッションに保持している検索条件を設定
    if (!this.checkSetConditions(e203SearchForm) && !screenSearchFlg) {
      let sessionSearchForm = JSON.parse(sessionStorage.getItem(this.sessionTagName));
      // セッションに値がなければ設定しない
      if (this.checkSetConditions(sessionSearchForm)) {
        // 画面の検索条件に反映する
        this.e203SearchForm.setValue(sessionSearchForm);
        // 検索条件に設定する
        e203SearchForm = JSON.parse(
          JSON.stringify(this.e203SearchForm.value)
        );
      }
    }

    // 配列をカンマ区切り変換
    {
      // ステータス
      if (!e203SearchForm.status) {
        e203SearchForm.status = '';
      } else {
        e203SearchForm.status = e203SearchForm.status.toString();
      }

      // ログインユーザ情報の会員IDをセット
      e203SearchForm.member_id = this.loginUser.member_id;
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(SUBCOMMITTEE_APPLICATION);

    // 分科会結果を取得
    this.dbOperationService
      .getNoTemplateData(
        SUBCOMMITTEE_APPLICATION,
        {
          status: e203SearchForm.status,
          date1: e203SearchForm.date1,
          date2: e203SearchForm.date2,
          member_id: this.loginUser.member_id,
          find_kbn: "C",
        },
        false
      )
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // 分科会検索結果結果を格納
          this.resultDataList = response.body;
        } else {
          this.resultDataList = new Array();
        }

        // 検索条件を保持
        sessionStorage.setItem(this.sessionTagName, JSON.stringify(this.e203SearchForm.value));

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, SUBCOMMITTEE_APPLICATION);
      });

    // テーブル状態が存在するか否か
    if (this.table) {
      // テーブル状態が存在する場合

      // テーブル状態をリセット
      this.table.reset();
    }
  }

  /**
   * 検索条件を削除
   */
  public clearConditions(): void {
    // 検索条件を削除
    this.e203SearchForm.reset();
    this.e203SearchForm.setValue({ status: '' });
    this.e203SearchForm.setValue({ date1: '' });
    this.e203SearchForm.setValue({ date2: '' });
  }

  /**
   * 分科会詳細(E202)へ遷移する
   * @param subcommitteeId 分科会ID
   */
  public moveE202(subcommitteeId: string): void {
    // 分科会詳細(E202)へ遷移
    this.router.navigate(['pages/platform/e202/' + subcommitteeId]);
  }

  /**
   * 分科会申請登録(E204)へ遷移する
   */
  public moveE204(): void {
    // 分科会申請登録(E204)へ遷移
    this.router.navigate(['pages/platform/e204/new'], {
      queryParams: {
        screenId: 'e204',
      },
    });
  }

  /**
   * 分科会申請ボタン表示判定
   * sys_configテーブルの設定値から表示可否を判定する
   */
  public checkAppliDate(): boolean {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(SUBCOMMITTEE_PERIOD_CHECK);

    // 表示判定結果を取得
    this.dbOperationService
      .getNoTemplateData(SUBCOMMITTEE_PERIOD_CHECK)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.dispCheck = response.body.iswithin_displayperiod;
        }
        // 結果判定
        if (this.dispCheck == 'True') {
          this.isDisplay = true;
        } else {
          this.isDisplay = false;
        }
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, SUBCOMMITTEE_PERIOD_CHECK);
      });
    return this.isDisplay;
  }

  /**
   * 検索条件が設定されているかチェックする
   * @param conditions
   * @returns boolean true:設定あり / false:未設定
   */
  public checkSetConditions(conditions: any): boolean {
    // 検索条件が存在するかチェック
    if (conditions === undefined || conditions === null) {
      return false;
    } else {
      // 検索条件が設定されているかチェック
      if (conditions["status"] || conditions["date1"] || conditions["date2"]) {
        return true;
      }
    }
    return false;
  }
}
